import newRequest from './newRequest'
import readNotification from './readNotification'

export const newRequestService = newRequest
export const readNotificationService = readNotification
